(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[445],{

/***/ 1366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

module.exports = ArrowLeftIcon;

/***/ }),

/***/ 1719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[slug]",
      function () {
        return __webpack_require__(5490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _graphcms_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(392);
/* harmony import */ var _root_components_atoms_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4357);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var RichText = function(_param1) {
    var renderers = _param1.renderers, rest1 = _objectWithoutProperties(_param1, [
        "renderers"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_graphcms_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, _objectSpread({
    }, rest1, {
        renderers: _objectSpread({
            a: function(_param) {
                var children = _param.children, openInNewTab = _param.openInNewTab, href = _param.href, rel = _param.rel, rest = _objectWithoutProperties(_param, [
                    "children",
                    "openInNewTab",
                    "href",
                    "rel"
                ]);
                if (href.match(/^https?:\/\/|^\/\//i)) {
                    return(//eslint-disable-next-line react/jsx-no-target-blank
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
                        href: href,
                        target: openInNewTab ? "_blank" : "_self",
                        rel: openInNewTab ? rel || "noopener noreferrer" : undefined
                    }, rest, {
                        children: children
                    })));
                }
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_root_components_atoms_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: href,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
                    }, rest, {
                        children: children
                    }))
                }));
            },
            img: function(props) {
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    src: props.src,
                    alt: props.altText,
                    width: props.width,
                    height: props.height
                }));
            },
            p: function(param) {
                var children = param.children;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: children
                }));
            },
            class: function(param) {
                var className = param.className, children = param.children;
                switch(className){
                    case "section":
                        {
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                className: "py-8",
                                children: children
                            }));
                        }
                    default:
                        {
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: className,
                                children: children
                            }));
                        }
                }
            }
        }, renderers)
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 5490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/atoms/RichText/index.tsx
var RichText = __webpack_require__(807);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(1366);
var ArrowLeftIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftIcon);
// EXTERNAL MODULE: ./src/components/icons/github.tsx
var github = __webpack_require__(3304);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 153 modules
var motion = __webpack_require__(1203);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 29 modules
var format = __webpack_require__(3329);
// EXTERNAL MODULE: ./src/utils/mapGCMSEnum.ts
var mapGCMSEnum = __webpack_require__(4232);
;// CONCATENATED MODULE: ./src/components/templates/project/index.tsx








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var animateIn = {
    hidden: {
        strokeDashoffset: 100
    },
    visible: {
        strokeDashoffset: 0
    }
};
var lineProps = {
    variants: animateIn,
    initial: "hidden",
    animate: "visible",
    pathLength: "100",
    strokeDasharray: "100",
    transition: {
        default: {
            duration: 1
        }
    },
    className: "stroke-current stroke-3 text-primary-main"
};
var Project = function(param) {
    var children = param.children, project = param.project;
    var router = (0,next_router.useRouter)();
    var returnURL = "/projects";
    var goBack = function(e) {
        e.preventDefault();
        router.push(returnURL);
    };
    var slug = project.slug, title = project.title, githubRepo = project.githubRepo, skills = project.skills, launchDate = project.launchDate, _rotation = project.rotation, rotation = _rotation === void 0 ? 0 : _rotation;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "project",
        className: "relative page-" + slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white bg-opacity-80 mr-10 lg:mr-20 xl:mr-32",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute w-full top-0 z-10 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1525 370",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "113",
                                    fill: "none",
                                    y2: "113",
                                    transform: "translate(1383 0) rotate(" + rotation + " 0 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "264",
                                    y2: "264",
                                    transform: "translate(512 0) rotate(" + rotation + " 0 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "113",
                                    y2: "113",
                                    transform: "translate(586 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "114",
                                    y2: "114",
                                    transform: "translate(806 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "335",
                                    y2: "335",
                                    transform: "translate(1190 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, _objectSpread({
                                    x2: "117",
                                    y2: "117",
                                    transform: "translate(1100 0) rotate(" + rotation + " 0 0)"
                                }, lineProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.path */.E.path, {
                                    initial: "hidden",
                                    animate: "visible",
                                    variants: {
                                        hidden: {
                                            opacity: 0
                                        },
                                        visible: {
                                            opacity: 1
                                        }
                                    },
                                    transition: {
                                        duration: 1
                                    },
                                    className: "fill-current text-gray-300",
                                    d: "M587,0 l112,112 h217 l-112,-112 Z"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative p-10 lg:p-20 z-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        whileHover: {
                                            x: -10
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: " uppercase font-bold flex items-center",
                                            href: "/projects",
                                            onClick: goBack,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftIcon_default()), {
                                                    className: "w-4 inline-block mr-4",
                                                    fill: "currentColor"
                                                }),
                                                "Back"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        initial: {
                                            opacity: 0
                                        },
                                        animate: {
                                            opacity: 1
                                        },
                                        exit: {
                                            opacity: 0
                                        },
                                        transition: {
                                            delay: 0.1
                                        },
                                        className: "pt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "text-primary-main",
                                            children: [
                                                title,
                                                githubRepo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    style: {
                                                        marginLeft: "1rem"
                                                    },
                                                    href: "https://github.com/callumbooth/" + githubRepo,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(github/* default */.Z, {
                                                        className: "w-8 inline-block",
                                                        fill: "currentColor"
                                                    })
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                        className: "mt-12 flex flex-w flex-row",
                                        initial: {
                                            opacity: 0
                                        },
                                        animate: {
                                            opacity: 1
                                        },
                                        exit: {
                                            opacity: 0
                                        },
                                        transition: {
                                            delay: 0.2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-1/2 sm:w-1/3 md:w-1/2 lg:w-1/3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "Skills used"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flex-wrap",
                                                        children: skills.map(function(skill, i) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-1/2",
                                                                children: (0,mapGCMSEnum/* default */.Z)(skill)
                                                            }, i));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-1/2 sm:w-2/3 md:w-1/2 lg:w-2/3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "Launched"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-2xl",
                                                        children: launchDate ? (0,format/* default */.Z)(new Date(launchDate), "MMMM yyyy") : "In Development"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                variants: {
                                    hidden: {
                                        opacity: 0
                                    },
                                    visible: {
                                        opacity: 1
                                    }
                                },
                                transition: {
                                    delay: 0.4
                                },
                                initial: "hidden",
                                animate: "visible",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "project-info",
                                        children: children
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "additonal-images"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var templates_project = (Project);

;// CONCATENATED MODULE: ./src/pages/projects/[slug].tsx




function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __N_SSG = true;
function Post(_param) {
    var preview = _param.preview, body = _param.body, rest = _objectWithoutProperties(_param, [
        "preview",
        "body"
    ]);
    var __typename = rest.__typename, project = _objectWithoutProperties(rest, [
        "__typename"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(templates_project, {
        project: project,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
            content: body.raw
        })
    }));
};


/***/ }),

/***/ 4232:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var mapGCMSEnum = function(str) {
    return str.replace("_", " ");
};
/* harmony default export */ __webpack_exports__["Z"] = (mapGCMSEnum);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,329,774,888,179], function() { return __webpack_exec__(1719); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);